import { authApi } from 'api';

/**
 * Get all guest members and guest athletes in a club
 * @param {string} clubId - The club ID
 * @returns {Promise} - The response from the API
 */
export const getGuestMembers = async (clubId) => {
  try {
    const response = await authApi.get(
      `/Guests/${clubId}/guest-members-profiles`
    );
    return response;
  } catch (err) {
    throw err;
  }
};

/**
 * Get all guest athletes in a club
 * @param {string} clubId - The club ID
 * @returns {Promise} - The response from the API
 */
export const getGuestAthletes = async (clubId) => {
  try {
    const response = await authApi.get(`/Guests/guest-athletes/${clubId}`);
    return response;
  } catch (err) {
    throw err;
  }
};

/**
 * Exports club guest athletes to a CSV file.
 *
 * @param {string} clubId - The unique identifier of the club.
 * @param {string[]} [athleteIds] - Athlete IDs to limit the file to. Omit to export every guest athlete.
 * @returns {Promise<Object>} - A promise that resolves with the CSV file blob.
 */
export const exportGuestAthletesToFile = async (clubId, athleteIds) => {
  return await authApi.post(
    `/Clubs/${clubId}/export-guest-athletes-csv`,
    athleteIds ? { athleteIds } : null,
    { responseType: 'blob' }
  );
};
